$(document).ready(function () {
    const ajaxPath = '/action/report/accountingInfo';
    let ajaxLockActive = false;

    $(document).on('submit', '#accounting_tool_form', function (event) {
        event.preventDefault();

        const $form = $(this);
        const $accountInput = $form.find('[name="account"]');
        const $submitButton = $form.find('#update_account_tool_result');
        const accountNumber = $.trim($accountInput.val());
        const errorTitle = $form.data('error-title') || 'Error';

        if (!/^\d+$/.test(accountNumber)) {
            displayTailwindAlert(
                errorTitle,
                $form.data('invalid-account-message'),
                '#accounting_tool_alert',
                'error',
                'replace',
                true
            );
            $accountInput.trigger('focus');
            return;
        }

        if (ajaxLockActive) {
            return;
        }

        ajaxLockActive = true;
        $submitButton.prop('disabled', true);
        $('#accounting_tool_alert').empty();

        $.ajax({
            type: 'GET',
            url: ajaxPath,
            data: {
                action: 'get_account_information',
                sync_code: $form.find('[name="account_sync_code"]').val(),
                account_number: accountNumber
            },
            dataType: 'json'
        }).done(function (response) {
            $('#accounting_tool_result_wrapper').html(response.html || '');
        }).fail(function () {
            displayTailwindAlert(
                errorTitle,
                $form.data('fetch-error-message'),
                '#accounting_tool_alert',
                'error',
                'replace',
                true
            );
        }).always(function () {
            ajaxLockActive = false;
            $submitButton.prop('disabled', false);
        });
    });
});
